(function () {
  'use strict';

  class ProductCountdown {
    constructor(countdown) {
      if (!countdown) {
        throw new Error('ProductCountdown: countdown is required');
      }

      this.init(countdown);
    }

    setup() {
      this.date = new Date(this.DOM.countdown.dataset.isodate);
      this.onceEnds = this.DOM.countdown.dataset.onceEnds;
      this.endLabel = this.DOM.countdown.dataset.endLabel;

      const countdownTime = this.date.getTime() - Date.now();
      if (countdownTime <= 0) {
        if (this.onceEnds === 'hide_the_timer') {
          this.DOM.countdown.style.display = 'none';
        }

        if (this.onceEnds === 'do_nothing') {
          this.DOM.value.innerHTML = this.endLabel;
        }
        return;
      }

      this.updateCountdown();
      this.startCountdown();
    }

    updateCountdown() {
      const countdownTime = this.date.getTime() - Date.now();

      if (countdownTime <= 0) {
        this.stopCountdown();
        this.renderCountdown({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        return;
      }

      const countdown = {
        days: Math.floor(countdownTime / (1000 * 60 * 60 * 24)),
        hours: Math.floor((countdownTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
        minutes: Math.floor((countdownTime % (1000 * 60 * 60)) / (1000 * 60)),
        seconds: Math.floor((countdownTime % (1000 * 60)) / 1000),
      };
      this.renderCountdown(countdown);
    }

    renderCountdown(countdown) {
      const s = window.accessibilityStrings;
      this.DOM.days.innerHTML = String(countdown.days).padStart(2, '0') + s.countdownDays;
      this.DOM.hours.innerHTML = String(countdown.hours).padStart(2, '0') + s.countdownHours;
      this.DOM.minutes.innerHTML = String(countdown.minutes).padStart(2, '0') + s.countdownMinutes;
      this.DOM.seconds.innerHTML = String(countdown.seconds).padStart(2, '0') + s.countdownSeconds;
    }

    startCountdown() {
      this.interval = setInterval(() => {
        this.updateCountdown();
      }, 1000);
    }

    stopCountdown() {
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
    }

    destroy() {
      if (this.DOM) {
        this.stopCountdown();
        this.DOM = undefined;
      }
    }

    init(countdown) {
      if (countdown) {
        this.DOM = {};
        this.DOM.countdown = countdown;
        this.DOM.value = countdown.querySelector('.js-value');
        this.DOM.days = countdown.querySelector('.js-days');
        this.DOM.hours = countdown.querySelector('.js-hours');
        this.DOM.minutes = countdown.querySelector('.js-minutes');
        this.DOM.seconds = countdown.querySelector('.js-seconds');

        this.interval = null;

        this.setup();
      }
    }
  }

  window.Universe.ProductCountdown = ProductCountdown;
})();
